import { Box, HStack, Stack, Text, VStack } from '@chakra-ui/react';
import ProductSectionList from '../productSectionList/ProductSectionList';
import Colors from '../../../../../config/colors';

interface Props {
    title: string;
    names: string[];
}

export default function ProductSection({ title, names }: Props) {
    return (
        <Stack>
            <Text color={Colors.darkGrey}>{title}</Text>
            <ProductSectionList names={names} />
        </Stack>
    );
}
